import ConfirmModal from "PFComponents/confirm/confirm_modal";
import InputFieldSet from "PFComponents/text/input_field_set";
import { SavedFilter } from "PFTypes/saved_filters";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type SaveAsViewModalProps = {
  views: SavedFilter[];
  onSave: (filterName: string | null) => void;
  onClose: () => void;
};

export const SaveAsViewModal = ({ views, onSave, onClose }: SaveAsViewModalProps): JSX.Element => {
  const { t } = useTranslation();
  const [viewName, setViewName] = useState<string | null>(null);

  const viewNameUsed = !!views.find(({ name }) => name === viewName);
  const handleSave = () => {
    onSave(viewName?.trim() || "");
    setViewName(null);
  };

  const isAcceptEnabled = viewName && !viewNameUsed && viewName.trim();

  return (
    <ConfirmModal
      title={t("filters.save.filterNameModalTitle")}
      handleOK={isAcceptEnabled ? handleSave : undefined}
      handleClose={() => {
        setViewName(null);
        onClose();
      }}
    >
      <InputFieldSet
        label={t("filters.save.filterName")}
        value={viewName ?? ""}
        inputType="text"
        maxLength={100}
        required={true}
        error={viewNameUsed ? t("filters.save.nameUsed") : ""}
        handleChange={setViewName}
      />
    </ConfirmModal>
  );
};
